export const BLOOD_GROUP_OPTIONS = [
  { label: "O Negative (O-)", value: "O-" },
  { label: "O Positive (O+)", value: "O+" },
  { label: "A Negative (A-)", value: "A-" },
  { label: "A Positive (A+)", value: "A+" },
  { label: "B Negative (B-)", value: "B-" },
  { label: "B Positive (B+)", value: "B+" },
  { label: "AB Negative (AB-)", value: "AB-" },
  { label: "AB Positive (AB+)", value: "AB+" },
  { label: "Don't Know", value: "Don't Know" },
];

export const MONDAL_NAME = [
  "Allapalli",
  "Annapureddipally",
  "Aswapuram",
  "Aswaraopeta",
  "Burgampadu",
  "Chandrugonda",
  "Cherla",
  "Chunchupally",
  "Dammapeta",
  "Dummugudem",
  "Gundala",
  "Karakagudem",
  "Laxmidevipalli",
  "Manguru",
  "Mulakalapalli",
  "Palvancha",
  "Pinapaka",
  "Tekulapally",
];

export const DELIVERY_DETAILS = ["Normal", "Home", "Institutional", "LSCS"];

export const FAMILY_PLANNING_COUNSLING = [
  "Oc pills",
  "Antara injection",
  "Cu T insertion",
  "Vasectomy",
  "Tubectomy",
];

export const TAGS = [
  { label: "ANC/PNC", value: "ANC/PNC" },
  {
    label: "Others",
    value: "Others",
  },
];

export const VISIT_TYPE = [
  {
    label: "In-Person",
    value: "INPERSON",
  },
  {
    label: "Appointment",
    value: "APPOINTMENT",
  },
  {
    label: "Follow-Up",
    value: "FOLLOWUP",
  },
];

export const VISIT_STATUS = [
  { label: "Upcoming", value: "UPCOMING" },
  { label: "Modified", value: "MODIFIED" },
  { label: "Cancelled", value: "CANCELLED" },
  { label: "Completed", value: "COMPLETED" },
  { label: "No-Show", value: "NOTSHOW" },
];

export const DEPARTMENT = [
  { label: "Anesthesiology", value: "ANESTHESIOLOGY" },
  // { label: "OPD", value: "OPD" },
  { label: "Cardiology", value: "CARDIOLOGY" },
  { label: "Dermatology", value: "DERMATOLOGY" },
  { label: "Emergency", value: "EMERGENCY" },
  { label: "Endocrinology", value: "ENDOCRINOLOGY" },
  { label: "Gastroenterology", value: "GASTROENTEROLOGY" },
  { label: "General", value: "GENERAL" },
  { label: "Neurology", value: "NEUROLOGY" },
  { label: "Onology", value: "ONCOLOGY" },
  { label: "Pediatrics", value: "PEDIATRICS" },
  { label: "Pulmonology", value: "PULMONOLOGY" },
];

export const SERVICE_TYPE = [
  {
    label: "Consultation",
    value: "CONSULTATION",
  },
  {
    label: "Out Patient (OPD)",
    value: "OPD",
  },
  {
    label: "In Patient",
    value: "INPATIENT",
  },
  {
    label: "Day care",
    value: "DAYCARE",
  },
];

export const MEDICATION_MEASUREMENT = [
  {
    label: "mg",
    value: "mg",
  },
  {
    label: "µg",
    value: "µg",
  },
  {
    label: "g",
    value: "g",
  },
  {
    label: "mL",
    value: "mL",
  },
  {
    label: "ng",
    value: "ng",
  },
];

export const TIMING = [
  {
    label: "After breakfast",
    value: "After breakfast",
  },
  {
    label: "Empty Stomach",
    value: "Empty Stomach",
  },
  {
    label: "After meal",
    value: "After meal",
  },
  {
    label: "Bed Time",
    value: "Bed Time",
  },
  { label: "SOS (when required)", value: "SOS (when required)" },
];

export const FREQUENCY_COUNT = [
  { label: "1-0-1", value: "1-0-1" },
  { label: "0-1-0", value: "0-1-0" },
  { label: "1-1-1", value: "1-1-1" },
  { label: "1-0-0", value: "1-0-0" },
  { label: "0-0-1", value: "0-0-1" },
  { label: "2-0-2", value: "2-0-2" },
  { label: "2-2-2", value: "2-2-2" },
  { label: "0-2-0", value: "0-2-0" },
  { label: "0-0-2", value: "0-0-2" },
  { label: "2-0-0", value: "2-0-0" },
  { label: "0-0-1/2", value: "0-0-1/2" },
  { label: "1/2-0-1/2", value: "1/2-0-1/2" },
  { label: "1/2-1/2-1/2", value: "1/2-1/2-1/2" },
  { label: "0-1/2-0", value: "0-1/2-0" },
  { label: "1/2-0-0", value: "1/2-0-0" },
];

export const DURATION = [
  { label: "1 day", value: "1 day" },
  { label: "5 days", value: "5 days" },
  { label: "7 days", value: "7 days" },
  { label: "2 days", value: "2 days" },
  { label: "3 days", value: "3 days" },
  { label: "4 days", value: "4 days" },
  { label: "6 days", value: "6 days" },
  { label: "8 days", value: "8 days" },
  { label: "9 days", value: "9 days" },
  { label: "10 days", value: "10 days" },
  { label: "11 days", value: "11 days" },
  { label: "12 days", value: "12 days" },
  { label: "13 days", value: "13 days" },
  { label: "14 days", value: "14 days" },
  { label: "15 days", value: "15 days" },
  { label: "20 days", value: "20 days" },
  { label: "30 days", value: "30 days" },
];

export const GENDER = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

export const LUNGS_OPTION = [
  "Crepts",
  "Wheeze",
  "Bilateral Air Entry",
  "Clear",
];

export const DOCTOR_SPECIALIZATION = [
  "Cardiology",
  "Dermatology",
  "Neurology",
  "Pediatrics",
  "Orthopedics",
  "Ophthalmology",
  "Gynecology",
  "Oncology",
  "Psychiatry",
  "Radiology",
  "Endocrinology",
  "Gastroenterology",
  "Hematology",
  "Nephrology",
  "Pulmonology",
  "Rheumatology",
  "Urology",
  "Anesthesiology",
  "Emergency Medicine",
  "Family Medicine",
  "Pathology",
  "Plastic Surgery",
  "General Surgery",
  "Vascular Surgery",
  "Neurosurgery",
];

export const DOCTOR_LIST = [
  "Dr. Devi Shetty",
  "Dr. Naresh Trehan",
  "Dr. Randeep Guleria",
  "Dr. Arvind Kumar",
  "Dr. B. C. Roy",
  "Dr. Prathap C. Reddy",
  "Dr. K. M. Cherian",
  "Dr. Lalit Kant",
  "Dr. Ramanathan V. Lakshmanan",
  "Dr. A. Velumani",
  "Dr. Sudarshan Ballal",
  "Dr. Farokh Udwadia",
  "Dr. Shashank Joshi",
  "Dr. S. Natarajan",
  "Dr. Ajay Kumar",
  "Dr. Vandana Luthra",
  "Dr. Ashok Seth",
  "Dr. Y. K. Mishra",
  "Dr. Padmavati Iyer",
  "Dr. S. K. Sarin",
  "Dr. Mammen Chandy",
  "Dr. Alok Srivastava",
  "Dr. Rakesh Yadav",
  "Dr. Rajesh Parikh",
  "Dr. N. S. Laud",
];

export const CATEGORY = [
  "Progress Note",
  "Lab Results",
  "Diagnosis",
  "Prescription",
  "Consultation Notes",
  "Follow-up instructions",
  "Surgical notes",
  "Discharge Summary",
];
export const VIEW_ABLE_PERSON_LIST = [
  "Doctors",
  "Nurses",
  "Lab Technicians",
  "Patient",
  "Admins",
  "All Medical Staff",
];

export const OBSTETRIC_COMPLICATION = [
  "APH",
  "Eclampsia",
  "PIH",
  "Anaemia",
  "Obstructed Labor",
  "PPH",
  "LSCS",
  "Congential anomaly in baby",
  "Others",
];

export const OBSTETRIC_COMPLICATION_PAST_HISTORY = [
  "Tuberculosis",
  "Hypertension",
  "Heart Disease",
  "Diabetes",
  "Asthma",
  "Others",
];

export const VISIT_TAGS = [
  "CONSULTATION",
  "FOLLOWUP",
  "EMERGENCY",
  "FIRSTVISIT",
  "TREATMENTPLANNING",
  "POSTOPCHECKUP",
  "REFERRAL",
  // "OTHERS",
];

export const USER_TYPE_OPTIONS = [
  // { label: "MMU Head", value: "MMUHEAD" },
  // { label: "MMU Staff", value: "MMUSTAFF" },
  // { label: "Admin", value: "ADMIN" },
  { label: "Marketing User", value: "MARKETING_USER" },
  { label: "Doctor Information Management User", value: "DOCTOR_INFO_MANAGEMENT_USER" },
];

export const ANS_VISIT_DETAILS_KEYS = {
  visitDate: "",
  ancCheckup: "",
  monthsOfPregnancy: "",
  complaints: "",
  weight: "",
  pallor: "",
  urinaryParams: "",
  temprature: "",
  pr: "",
  bp: "",
  sfhAgInCm: "",
  fhr: "",
  hb: "",
  scanEddReport: "",
  diagnosis: "",
  ironTablet: "",
  calciumTablet: "",
  neurocanForteTablet: "",
  ironSucroseDetails: "",
  referral: "",
};

export const MMU_UNIT = ["Pinapaka", "Cherla", "Burgampadu", "Parchaa"];

export const PERGNANCY_HIGH_RISK = [
  "Short stature < 145 cms",
  "Age < 18 and > 35 years",
  "Multi Parity (≥ 5 deliveries)",
  "Anaemia ≤ 7 gm/dl",
  "Previous Caesarean",
  "Gestational Diabetes",
  "RH Negative",
  "Placental Causes",
  "Mal Presentation",
  "3 or more abortions (RPL)",
  "Pregnancy with tumours",
  "Twin/Multiple pregnancy",
  "Pregnancy Induced Hypertension",
  "Syphilis / HIV / HbsAg",
  "Bad Obstetric History",
];

export const FORM_ID_MAPPING = {
  "8fc2f445-7003-4ae9-836c-4c12ffab1e87": "dental_form", // Treatment Plan
  "a23e15d8-935e-4735-b567-c544ea3f3c49": "upload_document", // Upload File
  "9576b57d-1896-46b6-a419-c6fda06f475e": "screening_form", // Screening Form
  "eb734843-93d6-4398-800d-6322b0da5df1": "vitals_record", // Vitals Form
};
